/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-18 15:09:02
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-11 22:32:16
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Display/index.tsx
 */
import React, { useState } from 'react';

import { Icon } from '@/src/tools/icon';
import { LinkModuleType } from '@/src/types/common/linkType';
import classnames from 'classnames';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Modal from '../Modal';
import styles from './style.module.less';
type Props = {
  disabled?: boolean;
  value: LinkValue;
  linkTypeFilter?: Array<string>;
  scopeVariables?: Record<any, string>;
  selectedLinkType?: Array<any>;
  excludeLinkType?: Array<any>;
  onChange: (type: LinkValue) => void;
  fetchProps?: { [propsName: string]: any };
  cannotAddToCart?: boolean;
  imageBottomComp?: React.ElementType;
  unableDelete?: boolean;
};

type LinkValue = {
  label: string;
  uuid: string;
  linkType: LinkModuleType;
  action: string;
  item?: any;
};

function Display({
  linkTypeFilter = [],
  onChange,
  scopeVariables,
  value,
  disabled,
  selectedLinkType,
  fetchProps,
  excludeLinkType,
  cannotAddToCart,
  imageBottomComp,
  unableDelete,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = useState(false);

  const handleDelete = (e) => {
    e.stopPropagation();
    onChange({
      label: null,
      linkType: null,
      uuid: null,
      action: null,
      item: {
        hasError: false,
      },
    });
  };

  const hasValue = !!get(value, 'linkType');

  return (
    <div
      className={classnames(styles.container, {
        [styles.disabled]: disabled,
      })}
      style={{ borderColor: value.item?.hasError ? '#FF695F' : undefined }}>
      <div
        className={styles.input}
        onClick={() => {
          if (!disabled) {
            setVisible(true);
          }
        }}>
        <span className={styles.value}>
          {hasValue ? (
            value.label
          ) : (
            <span
              style={{
                color: 'RGB(187, 187, 187)',
              }}>
              {getI18n('general.linkModule.Display.select_link')}
            </span>
          )}
        </span>
        {(value.uuid || value.linkType === 'None') &&
          !disabled &&
          !unableDelete && (
            <Icon
              type={'iconclose'}
              className={styles.icon}
              onClick={handleDelete}
            />
          )}
      </div>
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        linkTypeFilter={linkTypeFilter}
        scopeVariables={scopeVariables}
        value={value}
        onChange={onChange}
        selectedLinkType={selectedLinkType}
        excludeLinkType={excludeLinkType}
        fetchProps={fetchProps}
        cannotAddToCart={cannotAddToCart}
      />
    </div>
  );
}

export default Display;
